module.exports = __webpack_public_path__ + "static/media/d8.870e7e5f.jpg";